import { render } from "./EmailSignup.vue?vue&type=template&id=2befc9e2"
import script from "./EmailSignup.vue?vue&type=script&lang=js"
export * from "./EmailSignup.vue?vue&type=script&lang=js"

import exportComponent from "/Users/matthew/Documents/Vault/code/sal/ritual/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__